import React, { useEffect, useRef, useState } from "react";
import styles from './home.module.css';
import Helmet from "react-helmet";
import { Link as Linkto } from "react-router-dom";
import { Link } from 'react-scroll'
import { ArrowRight, Calendar, X } from 'react-feather';
//import Zoom from 'react-reveal/Zoom';
import Fade from 'react-reveal/Fade';
import Bounce from 'react-reveal/Bounce';
//import { Animator, ScrollContainer, ScrollPage, batch, FadeIn, Move, MoveIn, MoveOut, Sticky, StickyIn, ZoomIn } from "react-scroll-motion";
import Header from '../../components/HeaderPublic'
import Footer from '../../components/FooterPublic';
import { style } from "@material-ui/system";
import { SmartToaster, toast } from 'react-smart-toaster';
import axios from 'axios';
import { IconButton, Slide, Snackbar } from "@mui/material";
import Loader from "../../components/Loader";


// const ZoomInScrollOut = batch(StickyIn(), FadeIn(), ZoomIn());
// const FadeUp = batch(Fade(), Move(), Sticky());

function usePlayOnVisible(extraDelayMs = 0) {
  const ref = useRef(null);
  const [played, setPlayed] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          // Wait for Fade animation to finish, THEN play UI
          setTimeout(() => setPlayed(true), extraDelayMs);
          observer.unobserve(el);
        }
      },
      { threshold: 0.3 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [extraDelayMs]);

  return [ref, played];
}

function MaintenanceFeatures() {
  const [ref, played] = usePlayOnVisible(500);
  return (
    <Fade bottom delay={70}>
      <div className={styles.FeatureCard}>
        <div ref={ref}>
          <div className={`${styles.FeatureCardIcon} ${styles.FImaintenance}`}>
            <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"
                d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
            </svg>
          </div>
          <h3>Maintenance Management</h3>
          <p>Submit, assign, and track work orders from submission to close. Never lose a ticket again.</p>
          <div className={styles.FeatureCardUI}>
            <div className={`${styles.MiniTag} ${played ? styles.MiniTagVisible : ''}`}>
              ● In Progress
            </div>
            <div className={styles.MiniBarTrack}>
              <div className={`${styles.MiniBarFill} ${played ? styles.MiniBarFillPlayed : ''}`} />
            </div>
          </div>
        </div>
      </div>
    </Fade>
  );
}

function ResidentFeatures() {
  const [ref, played] = usePlayOnVisible(650);
  return (
    <Fade bottom delay={140}>
      <div className={styles.FeatureCard}>
        <div ref={ref}>
          <div className={`${styles.FeatureCardIcon} ${styles.FIcomm}`}>
            <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
                d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
          </div>
          <h3>Resident Communication</h3>
          <p>Unified inbox for texts, emails, and portal messages — everything in one thread per resident.</p>
          <div className={styles.FeatureCardUI}>
            <div className={styles.MiniMessages}>
              <div className={`${styles.MiniMsg} ${styles.MiniMsgIn} ${played ? styles.BubbleInPlayed : ''}`}>
                How's the repair going?
              </div>
              <div className={`${styles.MiniMsg} ${styles.MiniMsgOut} ${played ? styles.BubbleOutPlayed : ''}`}>
                Scheduled for tomorrow at 10am!
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fade>
  );
}

function PortfolioFeatures() {
  const [ref, played] = usePlayOnVisible(800);
  const bars = [
    { height: '50%', hi: false, delay: '0ms' },
    { height: '70%', hi: false, delay: '80ms' },
    { height: '90%', hi: true, delay: '160ms' },
    { height: '60%', hi: false, delay: '240ms' },
    { height: '80%', hi: true, delay: '320ms' },
  ];
  return (
    <Fade bottom delay={210}>
      <div className={styles.FeatureCard}>
        <div ref={ref}>
          <div className={`${styles.FeatureCardIcon} ${styles.FIportfolio}`}>
            <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
                d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
              <path stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
                d="M9 22V12h6v10" />
            </svg>
          </div>
          <h3>Portfolio Visibility</h3>
          <p>Roll-up dashboard across every property. Know what's happening at every door, at a glance.</p>
          <div className={`${styles.FeatureCardUI} ${styles.FeatureMiniChart}`}>
            {bars.map((b, i) => (
              <div
                key={i}
                className={`${styles.McBar} ${b.hi ? styles.McBarHi : ''}`}
                style={{
                  height: played ? b.height : '0%',
                  transitionDelay: played ? b.delay : '0ms',
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </Fade>
  );
}

function VendorFeatures() {
  const [ref, played] = usePlayOnVisible(950);
  return (
    <Fade bottom delay={280}>
      <div className={styles.FeatureCard}>
        <div ref={ref}>
          <div className={`${styles.FeatureCardIcon} ${styles.FIvendor}`}>
            <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"
                d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="1.8" />
              <path stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"
                d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
          </div>
          <h3>Vendor Coordination</h3>
          <p>Manage your vendor roster, dispatch work, and track completion without the phone tag.</p>
          <div className={styles.FeatureCardUI}>
            <div className={styles.MiniVendorList}>
              {[
                { dot: styles.MvDotGreen, label: 'PlumbRight Co.', rowDelay: '0ms', dotDelay: '80ms' },
                { dot: styles.MvDotYellow, label: 'CoolAir HVAC', rowDelay: '130ms', dotDelay: '210ms' },
              ].map(({ dot, label, rowDelay, dotDelay }) => (
                <div
                  key={label}
                  className={`${styles.MiniVendor} ${styles.VendorRow} ${played ? styles.VendorRowPlayed : ''}`}
                  style={{ transitionDelay: played ? rowDelay : '0ms' }}
                >
                  <span
                    className={`${styles.MvDot} ${dot} ${played ? styles.DotBouncePlayed : ''}`}
                    style={{ animationDelay: played ? dotDelay : '0ms' }}
                  />
                  {label}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Fade>
  );
}

function WorkFeatures() {
  const [ref, played] = usePlayOnVisible(1100);
  const items = [
    { type: 'step', label: 'Submitted', cls: styles.MtStepDone, delay: '0ms' },
    { type: 'line', cls: styles.MtLineDone, delay: '120ms' },
    { type: 'step', label: 'Assigned', cls: styles.MtStepDone, delay: '240ms' },
    { type: 'line', cls: styles.MtLineActive, delay: '360ms' },
    { type: 'step', label: 'In Progress', cls: styles.MtStepActive, delay: '480ms' },
  ];
  return (
    <Fade bottom delay={350}>
      <div className={styles.FeatureCard}>
        <div ref={ref}>
          <div className={`${styles.FeatureCardIcon} ${styles.FIworkorder}`}>
            <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"
                d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2M9 5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2M9 5h6M9 12h6M9 16h4" />
            </svg>
          </div>
          <h3>Work Order Tracking</h3>
          <p>From open to closed — every step documented, timestamped, and reported automatically.</p>
          <div className={styles.FeatureCardUI}>
            <div className={styles.MiniTimeline}>
              {items.map((item, i) =>
                item.type === 'step' ? (
                  <div
                    key={i}
                    className={`${styles.MtStep} ${item.cls} ${played ? styles.StepRevealPlayed : ''}`}
                    style={{ transitionDelay: played ? item.delay : '0ms' }}
                  >
                    {item.label}
                  </div>
                ) : (
                  <div
                    key={i}
                    className={`${styles.MtLine} ${item.cls} ${played ? styles.LineGrowPlayed : ''}`}
                    style={{ transitionDelay: played ? item.delay : '0ms' }}
                  />
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </Fade>
  );
}

function ExpenseFeatures() {
  const [ref, played] = usePlayOnVisible(1250);
  const [count, setCount] = useState(0);
  const rafRef = useRef(null);

  useEffect(() => {
    if (!played) return;
    const target = 68;
    const duration = 900;
    let start = null;
    const tick = (now) => {
      if (!start) start = now;
      const t = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      setCount(Math.round(eased * target));
      if (t < 1) rafRef.current = requestAnimationFrame(tick);
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, [played]);

  return (
    <Fade bottom delay={420}>
      <div className={styles.FeatureCard}>
        <div ref={ref}>
          <div className={`${styles.FeatureCardIcon} ${styles.FIexpense}`}>
            <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
              <rect x="1" y="4" width="22" height="16" rx="2" stroke="currentColor" strokeWidth="1.8" />
              <path stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" d="M1 10h22" />
            </svg>
          </div>
          <h3>Expense Monitoring</h3>
          <p>Track every cost against every property. Spot overruns before they become surprises.</p>
          <div className={styles.FeatureCardUI}>
            <div className={styles.MeLabel}>Monthly Budget</div>
            <div className={styles.MeTrack}>
              <div
                className={styles.MeFill}
                style={{ width: played ? '68%' : '0%' }}
              />
            </div>
            <div className={styles.MePct}>{count}% used</div>
          </div>
        </div>
      </div>
    </Fade>
  );
}

function ReportingFeatures() {
  const [ref, played] = usePlayOnVisible(1400);
  const bars = [
    { height: '40%', hi: true, delay: '0ms' },
    { height: '65%', hi: false, delay: '80ms' },
    { height: '50%', hi: false, delay: '160ms' },
    { height: '85%', hi: true, delay: '240ms' },
    { height: '70%', hi: false, delay: '320ms' },
  ];
  return (
    <Fade bottom delay={490}>
      <div className={styles.FeatureCard}>
        <div ref={ref}>
          <div className={`${styles.FeatureCardIcon} ${styles.FIanalytics}`}>
            <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
                d="M18 20V10M12 20V4M6 20v-6" />
            </svg>
          </div>
          <h3>Reporting &amp; Analytics</h3>
          <p>Pre-built and custom reports on maintenance trends, costs, response times, and more.</p>
          <div className={`${styles.FeatureCardUI} ${styles.FeatureMiniChart}`}>
            {bars.map((b, i) => (
              <div
                key={i}
                className={`${styles.McBar} ${b.hi ? styles.McBarHi : ''}`}
                style={{
                  height: played ? b.height : '0%',
                  transitionDelay: played ? b.delay : '0ms',
                }}
              />
            ))}
          </div>
        </div>
      </div>
    </Fade>
  );
}

function MobileFeatures() {
  const [ref, played] = usePlayOnVisible(1550);
  return (
    <Fade bottom delay={560}>
      <div className={styles.FeatureCard}>
        <div ref={ref}>
          <div className={`${styles.FeatureCardIcon} ${styles.FImobile}`}>
            <svg width="24" height="24" fill="none" viewBox="0 0 24 24">
              <rect x="5" y="2" width="14" height="20" rx="2" stroke="currentColor" strokeWidth="1.8" />
              <path stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" d="M12 18h.01" />
            </svg>
          </div>
          <h3>Mobile Operations</h3>
          <p>Field teams update work orders from their phone. No more clipboard delays or radio silence.</p>
          <div className={styles.FeatureCardUI}>
            <div className={styles.MiniMobile}>
              {[
                { text: '✓ Photo uploaded', delay: '0ms' },
                { text: '✓ Status updated', delay: '170ms' },
              ].map(({ text, delay }) => (
                <div
                  key={text}
                  className={`${styles.MmCheck} ${played ? styles.CheckSlidePlayed : ''}`}
                  style={{ transitionDelay: played ? delay : '0ms' }}
                >
                  {text}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Fade>
  );
}


class HomePage extends React.Component {
  constructor({ match, ...props }) {
    super(...arguments);

    this.state = {
      activeTab: '1',
      metricPlayed: false,
      userEmail: '',
      snackbarOpen: false,
      snackbarMsg: "",
      loading: false
    };
  }
  counterRef1 = React.createRef();
  counterRef2 = React.createRef();
  counterRef3 = React.createRef();
  counterRef4 = React.createRef();
  metricCardRef = React.createRef();

  componentDidMount() {
    // Inject animation style
    const style = document.createElement('style');
    style.id = 'tab-animation-style';

    style.textContent = `
      @keyframes tabFadeIn {
        from {
          opacity: 0;
          transform: translateY(10px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
    `;

    document.head.appendChild(style);

    this.counterObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.animateCounter(entry.target);

            this.counterObserver.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );

    if (this.counterRef1.current) {
      this.counterObserver.observe(this.counterRef1.current);
    }

    if (this.counterRef2.current) {
      this.counterObserver.observe(this.counterRef2.current);
    }

    if (this.counterRef3.current) {
      this.counterObserver.observe(this.counterRef3.current);
    }

    if (this.counterRef4.current) {
      this.counterObserver.observe(this.counterRef4.current);
    }

    this.metricObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.setState({
              metricPlayed: true,
            });

            this.metricObserver.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );

    if (this.metricCardRef.current) {
      this.metricObserver.observe(this.metricCardRef.current);
    }
  }

  componentWillUnmount() {
    const style = document.getElementById('tab-animation-style');

    if (style) {
      style.remove();
    }

    if (this.counterObserver) {
      this.counterObserver.disconnect();
    }

    if (this.metricObserver) {
      this.metricObserver.disconnect();
    }
  }

  handleTabClick = (tab) => {
    this.setState({
      activeTab: tab,
    });
  };

  animateCounter = (el) => {
    const target = parseInt(el.dataset.target, 10);

    const duration = 2000;

    const startTime = performance.now();

    const update = (now) => {
      const elapsed = now - startTime;

      const progress = Math.min(elapsed / duration, 1);

      // ease out cubic
      const eased = 1 - Math.pow(1 - progress, 3);

      el.textContent = Math.round(eased * target);

      if (progress < 1) {
        requestAnimationFrame(update);
      }
    };

    requestAnimationFrame(update);
  };

  bookDemo() {
    if (this.state?.userEmail === '') {
      toast.error('Please enter your mail id.');
      return false;
    }

    this.setState({ loading: true });

    return axios.post(process.env.REACT_APP_USER_API_URL + 'v1/contact-us-new', { email: this.state?.userEmail }).then(response => {
      this.setState({ loading: false, userEmail: '', snackbarOpen: true, snackbarMsg: "Thanks! Your demo request has been received. We’ll reach out shortly to arrange a time that works for you." });
    }).catch(error => {
      this.setState({ loading: false });
      if (typeof error.response !== 'undefined')
        toast.error(error.response.data.message);
    });
  }

  render() {
    const { activeTab } = this.state;

    return (<React.Fragment>
      {this.state?.loading && <Loader />}

      <Helmet title="Home" />

      <Header />

      <section className={`${styles.HeroMainSec}`} id="hero">
        <div className={`${styles.HeroBGPattern}`}></div>
        <div className={`${styles.HeroContainer}`}>

          <Fade bottom delay={50}>
            <div className={`${styles.HeroContent}`}>
              <div className={`${styles.HeroBadge}`}>
                <span className={`${styles.BadgeDot}`}></span>
                Built for Affordable & Workforce Housing
              </div>
              <h1 className={`${styles.HeroHeadline}`}>
                Smarter Operations.<br />
                <span className={`${styles.TextAccent}`}>Stronger Communities.</span>
              </h1>
              <p className={`${styles.HeroSub}`}>
                PropertyDek gives property managers the tools to run efficient,
                human-centered portfolios — so you can spend less time on operational
                chaos and more time building real community.
              </p>
              <div className={`${styles.HeroCtas}`}>
                <Link to="cta" className={`${styles.PrimaryBU} ${styles.BULarge}`}>
                  <svg width="18" height="18" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="2" stroke-linecap="round" d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"></path></svg>
                  Book a Demo
                </Link>
                <Link to="platform" className={`${styles.OutlineBU} ${styles.BULarge}`}>
                  See the Platform
                  <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M5 12h14M12 5l7 7-7 7"></path></svg>
                </Link>
              </div>
              <div className={`${styles.HeroTrust}`}>
                <div className={`${styles.TrustItem}`}>
                  <strong>1,000+</strong>
                  <span>Doors Managed</span>
                </div>
                <div className={`${styles.TrustDivider}`}></div>
                <div className={`${styles.TrustItem}`}>
                  <strong>42%</strong>
                  <span>Faster Response</span>
                </div>
                <div className={`${styles.TrustDivider}`}></div>
                <div className={`${styles.TrustItem}`}>
                  <strong>60+</strong>
                  <span>Teams Trust Us</span>
                </div>
              </div>
            </div>
          </Fade>
          <Fade right delay={100}>
            <div className={`${styles.HeroVisual}`}>

              <div className={`${styles.HeroPhoto}`}>
                <div className={`${styles.HeroPhotoGlow}`}></div>
                <img src="/static/img/HeroImg.webp" alt="PropertyDek dashboard with property managers and residents in a community" />
              </div>

              <div className={`${styles.FloatCard} ${styles.FloatCardTop}`} style={{ transform: 'translate(-0.41px, -0.300329px)' }}>
                <div className={`${styles.FCIcon} ${styles.FCIconGreen}`}>
                  <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" d="M20 6L9 17l-5-5"></path></svg>
                </div>
                <div className={`${styles.FCBody}`}>
                  <strong>Work Order Resolved</strong>
                  <span>Unit 3B · HVAC — just now</span>
                </div>
              </div>

              <div className={`${styles.FloatCard} ${styles.FloatCardBottom}`} style={{ transform: 'translate(0.41px, 0.300329px)' }}>
                <div className={`${styles.FCIcon} ${styles.FCIconCoral}`}>
                  <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" d="M18 20V10M12 20V4M6 20v-6"></path></svg>
                </div>
                <div className={`${styles.FCBody}`}>
                  <strong>Response Time ↓42%</strong>
                  <span>vs. 90-day average</span>
                </div>
              </div>

              <div className={`${styles.FloatCard} ${styles.FloatCardMessage}`} style={{ transform: 'translate(-0.41px, -0.300329px)' }}>
                <div className={`${styles.FCIcon} ${styles.FCIconPurple}`}>
                  <svg width="14" height="14" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                </div>
                <div className={`${styles.FCBody}`}>
                  <strong>3 Resident Messages</strong>
                  <span>Awaiting reply</span>
                </div>
              </div>

            </div>
          </Fade>

        </div>
        <div className={`${styles.HeroScroll}`}>
          <div className={`${styles.ScrollMouse}`}><div className={`${styles.ScrollWheel}`}></div></div>
          <span>Scroll to explore</span>
        </div>
      </section>

      <section className={`${styles.Section} ${styles.SectionLight}`} id="operations">
        <div className={`${styles.Container}`}>
          <Fade bottom delay={50}>
            <div className={`${styles.SectionHeader}`}>
              <div className={`${styles.SectionTag}`}>The Problem We Solve</div>
              <h2 className={`${styles.SectionTitle}`}>Property managers deserve better tools.<br />We built them.</h2>
              <p className={`${styles.SectionSub}`}>Before PropertyDek, teams juggle spreadsheets, phone calls, missed work orders, and communication silos — all while trying to take care of real people.</p>
            </div>
          </Fade>
          <div className={`${styles.OpsGrid}`}>
            <Fade bottom delay={80}>
              <div className={`${styles.OpsCard}`}>
                <div className={`${styles.OpsCardIcon} ${styles.OpsIcon1}`}>
                  <svg width="22" height="22" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="1.8" stroke-linecap="round" d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></svg>
                </div>
                <h3>Maintenance Chaos</h3>
                <p>Work orders fall through the cracks. Vendors ghost you. Residents wait weeks.</p>
                <div className={`${styles.OpsCardSolution}`}>
                  <span className={`${styles.SolutionTag}`}>PropertyDek solves this</span>
                  <p className={`${styles.SolutionText}`}>Centralized work order tracking, vendor dispatch, and real-time status updates.</p>
                </div>
              </div>
            </Fade>
            <Fade bottom delay={200}>
              <div className={`${styles.OpsCard}`}>
                <div className={`${styles.OpsCardIcon} ${styles.OpsIcon2}`}>
                  <svg width="22" height="22" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
                </div>
                <h3>Communication Gaps</h3>
                <p>Residents can't reach you. Messages get lost. Trust erodes one missed text at a time.</p>
                <div className={`${styles.OpsCardSolution}`}>
                  <span className={`${styles.SolutionTag}`}>PropertyDek solves this</span>
                  <p className={`${styles.SolutionText}`}>Unified resident messaging hub — email, text, and portal in one place.</p>
                </div>
              </div>
            </Fade>
            <Fade bottom delay={320}>
              <div className={`${styles.OpsCard}`}>
                <div className={`${styles.OpsCardIcon} ${styles.OpsIcon3}`}>
                  <svg width="22" height="22" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.8"></circle><path stroke="currentColor" stroke-width="1.8" stroke-linecap="round" d="M12 6v12M9 9h4.5a1.5 1.5 0 0 1 0 3h-3a1.5 1.5 0 0 0 0 3H15"></path></svg>
                </div>
                <h3>Expense Leakage</h3>
                <p>Duplicate invoices, untracked vendor costs, and surprise budget overruns bleed you dry.</p>
                <div className={`${styles.OpsCardSolution}`}>
                  <span className={`${styles.SolutionTag}`}>PropertyDek solves this</span>
                  <p className={`${styles.SolutionText}`}>Expense visibility and reporting across every property in your portfolio.</p>
                </div>
              </div>
            </Fade>
            <Fade bottom delay={440}>
              <div className={`${styles.OpsCard}`}>
                <div className={`${styles.OpsCardIcon} ${styles.OpsIcon4}`}>
                  <svg width="22" height="22" fill="none" viewBox="0 0 24 24"><rect x="2" y="3" width="20" height="14" rx="2" stroke="currentColor" stroke-width="1.8"></rect><path stroke="currentColor" stroke-width="1.8" stroke-linecap="round" d="M8 21h8M12 17v4"></path></svg>
                </div>
                <h3>Fragmented Systems</h3>
                <p>Five apps for five problems. Data nowhere. Decisions based on gut, not insight.</p>
                <div className={`${styles.OpsCardSolution}`}>
                  <span className={`${styles.SolutionTag}`}>PropertyDek solves this</span>
                  <p className={`${styles.SolutionText}`}>One platform. Every operation. Full portfolio visibility from a single dashboard.</p>
                </div>
              </div>
            </Fade>
          </div>
        </div>
      </section>

      <section className={`${styles.Section} ${styles.SectionWhite}`} id="features">
        <div className={`${styles.Container}`}>
          <Fade bottom delay={50}>
            <div className={`${styles.SectionHeader}`}>
              <div className={`${styles.SectionTag}`}>Platform Features</div>
              <h2 className={`${styles.SectionTitle}`}>Everything your operations team needs.<br />Nothing they don't.</h2>
              <p className={`${styles.SectionSub}`}>Designed specifically for portfolios under 1,000 doors — powerful enough to do the job, lean enough to stay out of the way.</p>
            </div>
          </Fade>
          <div className={`${styles.FeaturesGrid}`}>
            <MaintenanceFeatures />
            <ResidentFeatures />
            <PortfolioFeatures />
            <VendorFeatures />
            <WorkFeatures />
            <ExpenseFeatures />
            <ReportingFeatures />
            <MobileFeatures />
          </div>
        </div>
      </section>

      <section className={`${styles.Section} ${styles.ImpactSection}`} id="impact">
        <div className={`${styles.ImpactShape} ${styles.ImpactShape1}`}></div>
        <div className={`${styles.ImpactShape} ${styles.ImpactShape2}`}></div>
        <div className={`${styles.Container}`}>
          <div className={`${styles.ImpactLayout}`}>

            <Fade bottom delay={50}>
              <div className={`${styles.ImpactVisual}`}>
                <div className={`${styles.ImpactPhoto} ${styles.ImpactPhotoMain}`}>
                  <img src="/static/img/impact-community.webp" alt="Hands joined together representing human connection" loading="lazy" />
                </div>

                <div className={`${styles.ImpactBadge}`}>
                  <div className={`${styles.ImpactBadgeNum}`}>4.9<span>/5</span></div>
                  <div className={`${styles.ImpactBadgeLabel}`}>
                    Resident relationship<br />satisfaction score
                  </div>
                  <div className={`${styles.ImpactBadgeStars}`} aria-hidden="true">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path></svg>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path></svg>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path></svg>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path></svg>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path></svg>
                  </div>
                </div>

                <div className={`${styles.ImpactQuote}`}>
                  <span>“</span>
                  <p>My residents finally feel heard.</p>
                </div>
              </div>
            </Fade>

            <Fade bottom delay={120}>
              <div className={`${styles.ImpactContent}`}>
                <div className={`${styles.SectionTag}`}>Human Impact</div>
                <h2 className={`${styles.ImpactHeadline}`}>
                  Technology that gives you time back<br />
                  <span className={`${styles.TextAccent}`}>to do what matters most.</span>
                </h2>
                <p className={`${styles.ImpactSub}`}>
                  PropertyDek was built so property managers could stop drowning in
                  operational noise — and start building genuine relationships with
                  the residents who call their properties home.
                </p>

                <ul className={`${styles.ImpactList}`}>
                  <Fade bottom delay={220}>
                    <li className={`${styles.ImpactItem}`}>
                      <div className={`${styles.ImpactItemIcon}`}>
                        <svg width="22" height="22" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
                      </div>
                      <div className={`${styles.ImpactItemText}`}>
                        <h4>Stronger Resident Relationships</h4>
                        <p>When operations run smoothly, managers have time to actually connect with the people they serve.</p>
                      </div>
                    </li>
                  </Fade>
                  <Fade bottom delay={320}>
                    <li className={`${styles.ImpactItem}`}>
                      <div className={`${styles.ImpactItemIcon}`}>
                        <svg width="22" height="22" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="1.8"></circle><path stroke="currentColor" stroke-width="1.8" stroke-linecap="round" d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                      </div>
                      <div className={`${styles.ImpactItemText}`}>
                        <h4>Empowered Staff</h4>
                        <p>Give your team tools that actually help them — so they can do their best work and feel the difference.</p>
                      </div>
                    </li>
                  </Fade>
                  <Fade bottom delay={420}>
                    <li className={`${styles.ImpactItem}`}>
                      <div className={`${styles.ImpactItemIcon}`}>
                        <svg width="22" height="22" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><path stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M9 22V12h6v10"></path></svg>
                      </div>
                      <div className={`${styles.ImpactItemText}`}>
                        <h4>Happier Communities</h4>
                        <p>Faster maintenance, better communication, and genuine care create places people are proud to call home.</p>
                      </div>
                    </li>
                  </Fade>
                </ul>
              </div>
            </Fade>

          </div>
        </div>
      </section>

      <section className={`${styles.Section} ${styles.SectionLight}`} id="platform">
        <div className={`${styles.Container}`}>
          <Fade bottom delay={50}>
            <div className={`${styles.SectionHeader}`}>
              <div className={`${styles.SectionTag}`}>The Platform</div>
              <h2 className={`${styles.SectionTitle}`}>One platform. Every operation.</h2>
              <p className={`${styles.SectionSub}`}>Purpose-built for affordable housing teams who need clarity, speed, and simplicity — without enterprise bloat.</p>
            </div>
          </Fade>

          <div className={`${styles.Showcase}`}>
            <Fade bottom delay={50}>
              <div className={`${styles.ShowcaseTabs}`}>
                <button
                  className={`${styles.ShowcaseTab} ${activeTab === '1' ? styles.ShowcaseTabActive : ''
                    }`}
                  onClick={() => this.handleTabClick('1')}
                >
                  Maintenance
                </button>
                <button
                  className={`${styles.ShowcaseTab} ${activeTab === '2' ? styles.ShowcaseTabActive : ''
                    }`}
                  onClick={() => this.handleTabClick('2')}
                >
                  Messaging
                </button>
                <button
                  className={`${styles.ShowcaseTab} ${activeTab === '3' ? styles.ShowcaseTabActive : ''
                    }`}
                  onClick={() => this.handleTabClick('3')}
                >
                  Analytics
                </button>
                <button
                  className={`${styles.ShowcaseTab} ${activeTab === '4' ? styles.ShowcaseTabActive : ''
                    }`}
                  onClick={() => this.handleTabClick('4')}
                >
                  Mobile
                </button>
              </div>
            </Fade>

            <div className={`${styles.ShowcasePanels}`}>

              <div
                id="tab-1"
                className={`${styles.ShowcasePanel} ${activeTab === '1' ? styles.ShowcasePanelActive : ''
                  }`}
                style={{
                  animation:
                    activeTab === '1'
                      ? 'tabFadeIn .3s ease both'
                      : 'none',
                }}
              >
                <div className={`${styles.ShowcaseScreen}`}>
                  <div className={`${styles.ScreenBar}`}>
                    <div className={`${styles.DbDots}`}>
                      <span className={`${styles.Dot} ${styles.DotRed}`}></span>
                      <span className={`${styles.Dot} ${styles.DotYellow}`}></span>
                      <span className={`${styles.Dot} ${styles.DotGreen}`}></span>
                    </div>
                    <span className={`${styles.ScreenTitle}`}>Work Orders — Overview Portfolio</span>
                  </div>
                  <div className={`${styles.ScreenBody}`}>
                    <img src="/static/img/maintenanceTabImg.jpg" alt="" />
                  </div>
                </div>
                <div className={`${styles.ShowcaseCopy}`}>
                  <h3>Maintenance Management</h3>
                  <p>Every work order tracked from submission to completion. Set priorities, assign vendors, upload photos, and close tickets — all from one place.</p>
                  <ul className={`${styles.ShowcaseList}`}>
                    <li>Real-time status updates</li>
                    <li>Vendor dispatch &amp; communication</li>
                    <li>Photo documentation</li>
                    <li>Resident auto-notifications</li>
                  </ul>
                </div>
              </div>


              <div
                id="tab-2"
                className={`${styles.ShowcasePanel} ${activeTab === '2' ? styles.ShowcasePanelActive : ''
                  }`}
                style={{
                  animation:
                    activeTab === '2'
                      ? 'tabFadeIn .3s ease both'
                      : 'none',
                }}
              >
                <div className={`${styles.ShowcaseScreen} ${styles.Message}`}>
                  <div>
                    <img src="/static/img/MessageTabImg-new.png" alt="" />
                  </div>
                </div>
                <div className={`${styles.ShowcaseCopy}`}>
                  <h3>Resident Communication Hub</h3>
                  <p>Every resident conversation — whether by text, email, or portal message — lands in one unified inbox so nothing gets missed.</p>
                  <ul className={`${styles.ShowcaseList}`}>
                    <li>Unified multi-channel inbox</li>
                    <li>Automated maintenance notifications</li>
                    <li>Broadcast announcements</li>
                    <li>Full conversation history</li>
                  </ul>
                </div>
              </div>


              <div
                id="tab-3"
                className={`${styles.ShowcasePanel} ${activeTab === '3' ? styles.ShowcasePanelActive : ''
                  }`}
                style={{
                  animation:
                    activeTab === '3'
                      ? 'tabFadeIn .3s ease both'
                      : 'none',
                }}
              >
                <div className={`${styles.ShowcaseScreen}`}>
                  <div className={`${styles.ScreenBar}`}>
                    <div className={`${styles.DbDots}`}>
                      <span className={`${styles.Dot} ${styles.DotRed}`}></span>
                      <span className={`${styles.Dot} ${styles.DotYellow}`}></span>
                      <span className={`${styles.Dot} ${styles.DotGreen}`}></span>
                    </div>
                    <span className={`${styles.ScreenTitle}`}>Portfolio Analytics</span>
                  </div>
                  <div className={`${styles.ScreenBody} ${styles.ScreenBodyAnalytics}`}>
                    <img src="/static/img/AnalyticTabImg.jpg" alt="" />
                  </div>
                </div>
                <div className={`${styles.ShowcaseCopy}`}>
                  <h3>Reporting &amp; Analytics</h3>
                  <p>See the full picture of your portfolio performance. Pre-built dashboards and custom reports give you the data to make smart, fast decisions.</p>
                  <ul className={`${styles.ShowcaseList}`}>
                    <li>Portfolio-wide performance overview</li>
                    <li>Maintenance trend analysis</li>
                    <li>Vendor cost benchmarking</li>
                    <li>Exportable reports</li>
                  </ul>
                </div>
              </div>


              <div
                id="tab-4"
                className={`${styles.ShowcasePanel} ${activeTab === '4' ? styles.ShowcasePanelActive : ''
                  }`}
                style={{
                  animation:
                    activeTab === '4'
                      ? 'tabFadeIn .3s ease both'
                      : 'none',
                }}
              >
                <div className={`${styles.ShowcaseScreen} ${styles.ShowcaseScreenMobileWrap}`}>
                  <div className={`${styles.MobileDevice}`}>
                    <img src="/static/img/MobileTabImg.jpg" alt="" />
                  </div>
                </div>
                <div className={`${styles.ShowcaseCopy}`}>
                  <h3>Mobile-First Field Operations</h3>
                  <p>Your maintenance team works in the field — their tools should too. Update work orders, upload photos, and close tickets from any phone, anywhere.</p>
                  <ul className={`${styles.ShowcaseList}`}>
                    <li>Works on any smartphone</li>
                    <li>Photo &amp; video documentation</li>
                    <li>Push notifications for assignments</li>
                    <li>Offline-capable updates</li>
                  </ul>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      <section className={`${styles.Section} ${styles.SectionWhite}`} id="why">
        <div className={`${styles.Container}`}>
          <Fade bottom delay={50}>
            <div className={`${styles.SectionHeader}`}>
              <div className={`${styles.SectionTag}`}>Why PropertyDek</div>
              <h2 className={`${styles.SectionTitle}`}>Built for affordable housing.<br />Not adapted. Built.</h2>
              <p className={`${styles.SectionSub}`}>Most property management software was designed for luxury high-rises or large REITs. PropertyDek was built specifically for the affordable and workforce housing sector — where relationships matter more than square footage.</p>
            </div>
          </Fade>

          <div className={`${styles.WhyGrid}`}>
            <Fade bottom delay={80}>
              <div className={`${styles.WhyCard} ${styles.WhyCardCoral}`}>
                <div className={`${styles.WhyCardIcon}`}>
                  <svg width="32" height="32" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
                </div>
                <h3>Mission-Driven Focus</h3>
                <p className={`${styles.WhyCardDesc}`}>We built PropertyDek for affordable housing operators because we believe every resident — regardless of income — deserves a well-managed, responsive home.</p>
              </div>
            </Fade>
            <Fade bottom delay={200}>
              <div className={`${styles.WhyCard} ${styles.WhyCardPurple}`}>
                <div className={`${styles.WhyCardIcon}`}>
                  <svg width="32" height="32" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.8"></circle><path stroke="currentColor" stroke-width="1.8" stroke-linecap="round" d="M12 8v4l3 3"></path></svg>
                </div>
                <h3>Right-Sized Platform</h3>
                <p className={`${styles.WhyCardDesc}`}>Designed for portfolios under 1,000 doors. You get all the tools a large enterprise has — without the complexity, cost, and bloat built for someone else.</p>
              </div>
            </Fade>
            <Fade bottom delay={320}>
              <div className={`${styles.WhyCard} ${styles.WhyCardTeal}`}>
                <div className={`${styles.WhyCardIcon}`}>
                  <svg width="32" height="32" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4" stroke="currentColor" stroke-width="1.8"></circle><path stroke="currentColor" stroke-width="1.8" stroke-linecap="round" d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                </div>
                <h3>High-Touch Philosophy</h3>
                <p className={`${styles.WhyCardDesc}`}>We're not a faceless SaaS company. Our team partners with you on onboarding, configuration, and ongoing support — because your success is our mission.</p>
              </div>
            </Fade>
            <Fade bottom delay={440}>
              <div className={`${styles.WhyCard} ${styles.WhyCardAmber}`}>
                <div className={`${styles.WhyCardIcon}`}>
                  <svg width="32" height="32" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"></path></svg>
                </div>
                <h3>Fast Time-to-Value</h3>
                <p className={`${styles.WhyCardDesc}`}>Up and running in days, not months. Simple enough for your whole team to adopt with minimal training — powerful enough to transform how you operate.</p>
              </div>
            </Fade>
          </div>
        </div>
      </section>

      <section className={`${styles.Section} ${styles.MetricsSection}`}>
        <div className={`${styles.Container}`}>
          <Fade bottom delay={50}>
            <div className={`${styles.SectionHeader}`}>
              <div className={`${styles.SectionTag}`}>Results</div>
              <h2 className={`${styles.SectionTitle}`}>PropertyDek delivers real,<br /><span className={`${styles.TextAccent}`}>measurable results.</span></h2>
              <p className={`${styles.SectionSub}`}>Operational gains that show up where they matter — in your team's day, your budget, and your residents' experience.</p>
            </div>
          </Fade>

          <div className={`${styles.MetricsGrid}`}>
            <Fade bottom delay={80}>
              <div className={`${styles.MetricCard} ${styles.MetricCardCoral}`}>
                <div ref={this.metricCardRef}>
                  <div className={`${styles.MetricCardIcon}`}>
                    <svg width="22" height="22" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 2M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"></path></svg>
                  </div>
                  <div className={`${styles.MetricCardValue}`}>
                    <span ref={this.counterRef1} className="counter" data-target="42">42</span><i>%</i>
                  </div>
                  <div className={`${styles.MetricCardLabel}`}>Faster Maintenance Response</div>
                  <div className={`${styles.MetricCardSub}`}>Average time from submission to completion</div>
                  <div className={`${styles.MetricCardBar}`}>
                    <span
                      style={{
                        width: this.state.metricPlayed ? '78%' : '0%',
                        transitionDelay: '1s',
                      }}
                    />
                  </div>
                </div>
              </div>
            </Fade>
            <Fade bottom delay={200}>
              <div className={`${styles.MetricCard} ${styles.MetricCardPurple}`}>
                <div ref={this.metricCardRef}>
                  <div className={`${styles.MetricCardIcon}`}>
                    <svg width="22" height="22" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
                  </div>
                  <div className={`${styles.MetricCardValue}`}>
                    <span ref={this.counterRef2} className="counter" data-target="96">96</span><i>%</i>
                  </div>
                  <div className={`${styles.MetricCardLabel}`}>Resident Satisfaction Score</div>
                  <div className={`${styles.MetricCardSub}`}>Across managed portfolios on the platform</div>
                  <div className={`${styles.MetricCardBar}`}>
                    <span
                      style={{
                        width: this.state.metricPlayed ? '96%' : '0%',
                        transitionDelay: '1.25s',
                      }}
                    />
                  </div>
                </div>
              </div>
            </Fade>
            <Fade bottom delay={320}>
              <div className={`${styles.MetricCard} ${styles.MetricCardMint}`}>
                <div ref={this.metricCardRef}>
                  <div className={`${styles.MetricCardIcon}`}>
                    <svg width="22" height="22" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>
                  </div>
                  <div className={`${styles.MetricCardValue}`}>
                    <span ref={this.counterRef3} className="counter" data-target="30">30</span><i>%</i>
                  </div>
                  <div className={`${styles.MetricCardLabel}`}>Reduction in Operational Leakage</div>
                  <div className={`${styles.MetricCardSub}`}>Expense visibility eliminates avoidable costs</div>
                  <div className={`${styles.MetricCardBar}`}>
                    <span
                      style={{
                        width: this.state.metricPlayed ? '60%' : '0%',
                        transitionDelay: '1.5s',
                      }}
                    />
                  </div>
                </div>
              </div>
            </Fade>
            <Fade bottom delay={440}>
              <div className={`${styles.MetricCard} ${styles.MetricCardAmber}`}>
                <div ref={this.metricCardRef}>
                  <div className={`${styles.MetricCardIcon}`}>
                    <svg width="22" height="22" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M12 6v6l4 2M12 22A10 10 0 1 0 2 12"></path><path stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M2 12l3-3M2 12l3 3"></path></svg>
                  </div>
                  <div className={`${styles.MetricCardValue}`}>
                    <span ref={this.counterRef4} className="counter" data-target="8">8</span><i>h</i>
                  </div>
                  <div className={`${styles.MetricCardLabel}`}>Staff Time Saved Per Week</div>
                  <div className={`${styles.MetricCardSub}`}>Per manager, on average, through automation</div>
                  <div className={`${styles.MetricCardBar}`}>
                    <span
                      style={{
                        width: this.state.metricPlayed ? '70%' : '0%',
                        transitionDelay: '1.75s',
                      }}
                    />
                  </div>
                </div>
              </div>
            </Fade>
          </div>
        </div>
      </section>

      <section className={`${styles.Section} ${styles.SectionWhite}`} id="testimonials">
        <div className={`${styles.Container}`}>
          <Fade bottom delay={50}>
            <div className={`${styles.SectionHeader}`}>
              <div className={`${styles.SectionTag}`}>Community Stories</div>
              <h2 className={`${styles.SectionTitle}`}>Hear from the people using PropertyDek every day.</h2>
            </div>
          </Fade>

          <div className={`${styles.TestimonialsGrid}`}>
            <Fade bottom delay={100}>
              <div className={`${styles.TestimonialCard}`}>
                <div className={`${styles.TestimonialCardQuote}`}>“</div>
                <p className={`${styles.TestimonialCardText}`}>Before PropertyDek, I was spending my whole day chasing work orders and playing phone tag with vendors. Now I actually have time to walk the property and talk to residents. That's what I got into this job for.</p>
                <div className={`${styles.TestimonialCardAuthor}`}>
                  <img src="/static/img/avatars/avatar-1.jpg" alt="Maria R." loading="lazy" />
                  <div className={`${styles.AuthorInfo}`}>
                    <strong>Maria R.</strong>
                    <span>Property Manager · Oakview Properties</span>
                  </div>
                </div>
              </div>
            </Fade>
            <Fade bottom delay={200}>
              <div className={`${styles.TestimonialCard}`}>
                <div className={`${styles.TestimonialCardQuote}`}>“</div>
                <p className={`${styles.TestimonialCardText}`}>The maintenance tracking alone was worth switching. My whole team is on the same page — no more "I didn't know about that" moments. Residents notice the difference in how quickly we respond.</p>
                <div className={`${styles.TestimonialCardAuthor}`}>
                  <img src="/static/img/avatars/avatar-2.jpg" alt="James T." loading="lazy" />
                  <div className={`${styles.AuthorInfo}`}>
                    <strong>James T.</strong>
                    <span>Portfolio Director · Harbor View Group</span>
                  </div>
                </div>
              </div>
            </Fade>
            <Fade bottom delay={300}>
              <div className={`${styles.TestimonialCard}`}>
                <div className={`${styles.TestimonialCardQuote}`}>“</div>
                <p className={`${styles.TestimonialCardText}`}>As a resident, I used to wonder if my maintenance request even went anywhere. Now I get updates automatically. I know exactly what's happening. It feels like they actually care — and they do.</p>
                <div className={`${styles.TestimonialCardAuthor}`}>
                  <img src="/static/img/avatars/avatar-3.jpg" alt="Denise M." loading="lazy" />
                  <div className={`${styles.AuthorInfo}`}>
                    <strong>Denise M.</strong>
                    <span>Resident · Riverside Housing Community</span>
                  </div>
                </div>
              </div>
            </Fade>
          </div>
        </div>
      </section>

      <section className={`${styles.Section} ${styles.PeopleSection}`} id="ourmission">
        <div className={`${styles.PeopleBgPanel}`}></div>
        <div className={`${styles.Container}`}>
          <div className={`${styles.PeopleLayout}`}>

            <Fade bottom delay={50}>
              <div className={`${styles.PeopleMessage}`}>
                <div className={`${styles.SectionTag}`}>Our Mission</div>
                <h2 className={styles.PeopleHeadline}>
                  Property management is a <span className={`${styles.TextAccent}`}>people business.</span>
                </h2>
                <p className={`${styles.PeopleText}`}>
                  Every tool we build at PropertyDek exists to free up the humans behind
                  the operations — so they can do what technology never can:
                  <strong>show up for the people they serve.</strong>
                </p>
                <div className={`${styles.PeopleStats}`}>
                  <div className={`${styles.PeopleStat}`}>
                    <div className={`${styles.PeopleStatNum}`}>120<span>k+</span></div>
                    <div className={`${styles.PeopleStatLabel}`}>Residents impacted</div>
                  </div>
                  <div className={`${styles.PeopleStatDivider}`}></div>
                  <div className={`${styles.PeopleStat}`}>
                    <div className={`${styles.PeopleStatNum}`}>38<span>+</span></div>
                    <div className={`${styles.PeopleStatLabel}`}>Communities served</div>
                  </div>
                </div>
                {/* <div className={`${styles.PeopleCtas}`}>
                  <a href="" className={`${styles.PrimaryBU} ${styles.BULarge}`}>
                    Join the Mission
                    <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M5 12h14M13 5l7 7-7 7"></path></svg>
                  </a>
                  <a href="" className={`${styles.PeopleLink}`}>Read our story →</a>
                </div> */}
              </div>
            </Fade>

            <Fade bottom delay={200}>
              <div className={`${styles.PeopleGallery}`}>
                <div className={`${styles.PeopleImg} ${styles.PeopleImgMain}`}>
                  <img src="/static/img/multifamily.webp" alt="Community life in a vibrant apartment complex" className={`${styles.GalleryCrop} ${styles.GalleryCropCenter}`} />
                  <div className={`${styles.PeopleImgTag}`}>Building real relationships</div>
                </div>

                <div className={`${styles.PeopleGalleryQuote}`}>
                  <div className={`${styles.PeopleQuoteAvatar}`}>
                    <img src="/static/img/avatars/avatar-4.jpg" alt="" />
                  </div>
                  <div>
                    <p>"PropertyDek gave me my Mondays back."</p>
                    <span>— Maria R., Property Manager</span>
                  </div>
                </div>
              </div>
            </Fade>

          </div>
        </div>
      </section>

      <section className={`${styles.Section} ${styles.CtaSection}`} id="cta">
        <div className={`${styles.CtaBgPattern}`}></div>
        <div className={`${styles.Container}`}>
          <Fade bottom delay={50}>
            <div className={`${styles.CtaContent}`}>
              <div className={`${styles.SectionTag} ${styles.SectionTagLight}`}>Get Started</div>
              <h2 className={`${styles.CtaHeadline}`}>Better housing operations<br />create better communities.</h2>
              <p className={`${styles.CtaSub}`}>See how PropertyDek can transform your team's operations — and your residents' experience — in a personalized 30-minute demo.</p>
              <div className={`${styles.CtaForm}`}>
                <div className={`${styles.CtaInputWrap}`}>
                  <input type="email" className={`${styles.CtaInput}`} placeholder="Enter your work email" aria-label="Work email" value={this.state?.userEmail} onChange={(e) => this.setState({ userEmail: e.target.value })} />
                  <button className={`${styles.PrimaryBU} ${styles.CtaSubmit}`} onClick={(e) => this.bookDemo()}>Book a Demo</button>
                </div>
                <p className={`${styles.CtaPrivacy}`}>No credit card. No obligation. We'll reach out within one business day.</p>
              </div>
              <div className={`${styles.CtaTrust}`}>
                <div className={`${styles.CtaTrustItem}`}>
                  <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M20 6L9 17l-5-5"></path></svg>
                  Free onboarding
                </div>
                <div className={`${styles.CtaTrustItem}`}>
                  <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M20 6L9 17l-5-5"></path></svg>
                  Dedicated support
                </div>
                <div className={`${styles.CtaTrustItem}`}>
                  <svg width="16" height="16" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M20 6L9 17l-5-5"></path></svg>
                  Up &amp; running in days
                </div>
              </div>
            </div>
          </Fade>
        </div>
      </section>

      <Snackbar
        open={this.state?.snackbarOpen}
        onClose={(e) => this.setState({ snackbarOpen: false })}
        TransitionComponent={Slide}
        message={this.state?.snackbarMsg}
        autoHideDuration={10000}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={(e) => this.setState({ snackbarOpen: false })}
          >
            <X />
          </IconButton>
        }
      />

      <SmartToaster
        store={toast}
        lightBackground={true}
        position={"top_center"}
      />

      <Footer />

    </React.Fragment >);
  }
}


export default HomePage;